import ForgotPasswordCard from "../../Components/ForgotPasswordCard";
import Masthead from "../../Components/Masthead";
import PurchaseTokensCard from "../../Components/PurchaseTokensCard";
import ShotListTable from "../../Components/ShotListTable";
import SignIn from "../../Components/SignInCard";
import SignUp from "../../Components/SignUpCard";

import handleNavigation from "../../Components/handleNavigate";
import './ShotListPage.css';
import { useContext, useEffect, useState } from "react";
import { StoryboardStateContext } from "../../Contexts/StoryboardStateContext";
import { Button, Checkbox, Modal, FloatingChat } from "@nxtvid/component-library";
import exportShotListToPDF from '../../Utilities/exportShotListToPDF';
import saveStoryboard from "../../Services/saveStoryboard";
import { AuthContext } from "../../Contexts/AuthContext";
import { UserContext } from "../../Contexts/UserContext";
import { handleSendMessageToShotListAgent } from "./services/handleSendMessageToShotListAgent";
import { getEntireShotListState } from "./agent_run_functions/getEntireShotListState";
import { getSingleShot } from "./agent_run_functions/getSingleShot";
import { changeSingleValue } from "./agent_run_functions/changeSingleValue";
import { changeMultipleValues } from "./agent_run_functions/changeMultipleValues";
import { addNewShot } from "./agent_run_functions/addNewShot";
import { deleteShot } from "./agent_run_functions/deleteShot";
import { addIdentifierToShots } from "./agent_run_functions/addIdentifierToShots";
import { parseGeminiMessageShot } from "./Utilities/parseGeminiMessageShot";

const ShotListPage = () =>{
  const [shotListHistory, setShotListHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(0);
  const {storyboardState, setStoryboardState} = useContext(StoryboardStateContext)    
  const navigate = require('react-router-dom').useNavigate();
  const [smallButtons, setSmallButtons] = useState(false);
  const exportIcon = require('../../Images/export-icon.png');
  const saveIcon = require('../../Images/save-icon.png');
  const backIcon  = require('../../Images/back-icon.png');
  const undoIcon = require('../../Images/undo-icon.png');
  const redoIcon = require('../../Images/redo-icon.png');
  const {isAuthenticated } = useContext(AuthContext)
  const {userInfo} = useContext(UserContext)
  const [canEdit, setCanEdit] = useState(false);
  const [isShotListComplete, setIsShotListComplete] = useState(storyboardState.shotListState === 'Complete' ? true : false);
  const [chatSession, setChatSession] = useState([]);

  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalType, setModalType] = useState('confirm')
  const [modalSize, setModalSize] = useState('medium')
  const [modalTitle, setModalTitle] = useState('')
  const [modalDescription, setModalDescription] = useState('' )
  const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
  const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
  const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
  const [modalCancelButtonText, setModalCancelButtonText] = useState('')
  const [modalChildren, setModalChildren] = useState(null);

  const [shotListState, setShotListState] = useState(
    addIdentifierToShots(storyboardState.shotList.length < 1? 
      [{
        //add index key to demo
        "Shot Number": "1",
        "Description/Action": "",
        "Shot Type": "",
        "Camera Movement": "",
        "Location": "",
        "Notes": ""
    },
    {
        "Shot Number": "2",
        "Description/Action": "",
        "Shot Type": "",
        "Camera Movement": "",
        "Location": "",
        "Notes": ""
    },
    {
        "Shot Number": "3",
        "Description/Action": "",
        "Shot Type": "",
        "Camera Movement": "",
        "Location": "",
        "Notes": ""
    },
    {
        "Shot Number": "4",
        "Description/Action": "",
        "Shot Type": "",
        "Camera Movement": "",
        "Location": "",
        "Notes": ""
    }] : storyboardState.shotList));

    //instantiate the chat session with the user info
    useEffect(() => {
      if (isAuthenticated === null) return;
      const todaysDate = new Date();
      setChatSession([
        {role: "user", parts: [{ text: `AdditionalContext: The user's name is ${userInfo.firstName} ${userInfo.lastName}. They work at ${userInfo.company}. And today's date is ${todaysDate}` }]}, 
        {role: "model", parts: [{ text: `Hey, ${userInfo.firstName}! I see you're building a shot list. Let me know if there's anything I can do to help!` }]}, 
    ])
    },[userInfo])
    


    const query = new URLSearchParams(window.location.search);
        const projectId = query.get("projectId");
        
        useEffect(() => {
          if (isAuthenticated === null || !userInfo) return;
          if (storyboardState.shotListState === 'Not Started') return;
        
          if (!projectId) {
            navigate("/");
            return;
          }
        
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        
          fetch(`${API_BASE_URL}/api/getProject`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ projectId, userId: userInfo._id }),
          })
            .then(async res => {
              if (res.status === 400) {
                setIsModalOpen(true)
                setModalType("alert")
                setModalTitle("Error")
                setModalChildren(null)
                setModalDescription("This project does not exist.")
                setModalSize("medium")
                setModalOnConfirm(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalOnCancel(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalConfirmButtonText("OK")
                setModalCancelButtonText("Cancel")
                
              }
        
              if (res.status === 403) {
                setIsModalOpen(true)
                setModalType("alert")
                setModalTitle("Error")
                setModalChildren(null)
                setModalDescription("You do not have access to this project.")
                setModalSize("medium")
                setModalOnConfirm(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalOnCancel(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalConfirmButtonText("OK")
                setModalCancelButtonText("Cancel")
                
              }
        
              if (!res.ok) throw new Error("Failed to fetch project");
        
              const { project, access } = await res.json();
              setStoryboardState(project);
              setShotListState(addIdentifierToShots(project.shotList));
              setCanEdit(access === "editor");
            })
            .catch(err => {
              console.error("Error loading project:", err);
            });
        }, [projectId, userInfo]);


    useEffect(() => {
        const checkWindowSize = () => {
          if (window.innerWidth < 768) {
            setSmallButtons(true);
          } else {
            setSmallButtons(false);
          }
        };
    
        // Initial check
        checkWindowSize();
    
        // Add event listener
        window.addEventListener('resize', checkWindowSize);
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener('resize', checkWindowSize);
        };
      }, []);

// run agentic functions when the chat session updates
      useEffect(()=>{
              const lastMessage = chatSession[chatSession.length - 1];
              if (!lastMessage || !lastMessage.parts) return;
              const functionCallPart = lastMessage.parts.find(part => part.functionCall);
              if (functionCallPart?.functionCall?.name === 'get_entire_shotlist_state') {
                  getEntireShotListState(chatSession, shotListState, setChatSession, userInfo);
              }
              else if (functionCallPart?.functionCall?.name === 'get_single_shot') {
                getSingleShot(functionCallPart.functionCall.args.index, chatSession, shotListState, setChatSession, userInfo);
              }
              else if (functionCallPart?.functionCall?.name === 'change_single_value') {
                const index = functionCallPart.functionCall.args.index;
                const field = functionCallPart.functionCall.args.field;
                const value = functionCallPart.functionCall.args.new_value;
                changeSingleValue(
                  index,
                  field,
                  value,
                  chatSession,
                  shotListState,
                  setShotListState,
                  setChatSession,
                  userInfo,
                  shotListHistory,
                  setShotListHistory,
                  historyIndex,
                  setHistoryIndex
                );
              }
              else if (functionCallPart?.functionCall?.name === 'change_multiple_values') {
                const changes = functionCallPart.functionCall.args.changes;
                changeMultipleValues(
                  changes,
                  chatSession,
                  shotListState,
                  setShotListState,
                  setChatSession,
                  userInfo,
                  shotListHistory,
                  setShotListHistory,
                  historyIndex,
                  setHistoryIndex
                );
              }
              else if (functionCallPart?.functionCall?.name === 'add_new_shot') {
                const newShot = functionCallPart.functionCall.args.inserts[0];
                addNewShot(
                newShot,
                chatSession,
                shotListState,
                setShotListState,
                setChatSession,
                userInfo,
                shotListHistory,
                setShotListHistory,
                historyIndex,
                setHistoryIndex
              );
              }
              else if (functionCallPart?.functionCall?.name === 'delete_shot') {
                const args = functionCallPart.functionCall.args;
                deleteShot(
                  args,
                  chatSession,
                  shotListState,
                  setShotListState,
                  setChatSession,
                  userInfo,
                  setIsModalOpen,
                  setModalTitle,
                  setModalDescription,
                  setModalOnConfirm,
                  setModalOnCancel,
                  setModalCancelButtonText,
                  setModalConfirmButtonText,
                  shotListHistory,
                  setShotListHistory,
                  historyIndex,
                  setHistoryIndex,
                  setModalChildren,
                  modalChildren
                );
              }
          }, [chatSession])


  const handleSave = async() => {
    const newProjectState = {...storyboardState, shotList: shotListState};
    if (isShotListComplete) {
      newProjectState.shotListState = "Complete";
    }
    else{
      newProjectState.shotListState = "In Progress";
    }
    setStoryboardState(newProjectState);
    const result = await saveStoryboard(newProjectState);
    setIsModalOpen(true)
    setModalType("alert")
    setModalChildren(null);
    result === 'Success' ? setModalTitle("Shot List Saved") : setModalTitle("Error")
    result === 'Success' ? setModalDescription("Your shot list has been saved successfully!") : setModalDescription("There was an error saving your shot list. Please try again.")
    setModalSize("medium")
    setModalOnConfirm(() => () => {
      setIsModalOpen(false);
    });
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    })
    setModalConfirmButtonText("OK")
  };

  const handleUndo = () => {
    if (historyIndex > 0) {
        // if shotListHistory doesn't have the current state, add it
        if (!shotListHistory.includes(shotListState)) {
            setShotListHistory([...shotListHistory.slice(0, historyIndex), shotListState]);
        }
        setShotListState(shotListHistory[historyIndex - 1]);
        setHistoryIndex(historyIndex - 1);
    }
};

// function to redo the last action
const handleRedo = () => {
    if (historyIndex < shotListHistory.length - 1) {
        setShotListState(shotListHistory[historyIndex+1]);
        setHistoryIndex(historyIndex + 1);
    }
};

const handleBackToDashboard = () => {
  setModalType("confirm")
  setModalSize("medium")
  setModalChildren(null);
  setModalTitle("Back to Dashboard")
  setModalDescription("Are you sure you want to leave this page? Your work won't automatically be saved.")
  setModalOnConfirm(() => () => {
    setIsModalOpen(false);
    handleNavigation({path: "/", navigate});
  });
  setModalOnCancel(() => () => {
    setIsModalOpen(false);
  });
  setModalConfirmButtonText("Go to Dashboard")
  setModalCancelButtonText("Cancel")
  setIsModalOpen(true)
}


  return(
        <div className="App-ShotListPage">
        {isModalOpen ? <Modal size={modalSize} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText} children = { modalChildren }/> : null}
        <h3 className="shotListPage-ProjectTitle">{storyboardState.projectTitle}</h3>
        <div className='shotlist-header'>
          <div className='shotlist-header-left-side'>
            <Button toolTipMessage='Back to Dashboard' size={smallButtons ? 'small' : 'medium'} icon={smallButtons ? backIcon : ''} label ='Back To Dashboard' onClick={handleBackToDashboard}/>
            <Button toolTipMessage = 'Save Shot List' size={smallButtons ? 'small' : 'medium'} icon={smallButtons ? saveIcon : ''} label='Save Shot List' onClick={()=>{handleSave() }}/>
            <Button toolTipMessage = 'Export to PDF' size={smallButtons ? 'small' : 'medium'} icon={smallButtons ? exportIcon : ''} label='Export to PDF' onClick={()=>{exportShotListToPDF(storyboardState, shotListState)}}/>
          </div>
          
        <div className='shotlist-undo-redo'>
            <Button toolTipMessage='Undo' size='small' label='' onClick = {handleUndo} disabled = {historyIndex > 0 ? false : true} icon={undoIcon}/>
            <Button toolTipMessage='Redo' size='small' label='' onClick = {handleRedo} disabled = {historyIndex < shotListHistory.length -1 ? false : true} icon={redoIcon}/>
        </div>
        </div>
    
        <div className="shotList-state-checkbox-container">
           <Checkbox isChecked={isShotListComplete} setIsChecked={setIsShotListComplete}/>
           <p>Completed?</p>
        </div>
        <ShotListTable  shotListState={shotListState} setShotListState ={setShotListState} shotListHistory = {shotListHistory} setShotListHistory={setShotListHistory} historyIndex={historyIndex} setHistoryIndex={setHistoryIndex}/>
         
        <FloatingChat sendMessage={(message)=>handleSendMessageToShotListAgent(message, chatSession, setChatSession, userInfo)} chatSession={chatSession} chatHeader='Shot List Agent' />
    </div>
    )
}
export default ShotListPage;